module.exports = __webpack_public_path__ + "img/nodeBackgroundDrawGrid.4a72832d.svg";